<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <i class="uil-home-alt"></i>
            </router-link>
          </li>
          <li>
            {{ $t('report.company_dashboard.reports') }}
          </li>
          <li>{{ $t('general.user_content_report') }}</li>
        </ul>
      </nav>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left"><span>{{ $t('general.user_content_report') }} </span></h2>
      </div>
    </div>

    <p v-if="infoMessage" class="mb-3" style="color: red; font-size: 1.15rem; font-weight: 500;">
      <i class="uil-exclamation-triangle"></i> {{ infoMessage }}
    </p>

    <div class="card">
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">
          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                     class="uk-search-input shadow-0 uk-form-small" type="search"/>
            </div>
          </div>
          <div class="d-flex">
            <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover  btn-circle"
               href="javascript:void(0)" title="">
              <i class="uil-list-ui-alt"></i>
            </a>
            <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
              <ul class="uk-nav uk-dropdown-nav">
                <li class="uk-active"><a href="javascript:void(0)" @click="sortOrder('asc', 'name')">{{
                    $t('sorting.a_z')
                  }}</a></li>
                <li><a href="javascript:void(0)" @click="sortOrder('desc', 'name')">{{ $t('sorting.z_a') }}</a></li>
                <li><a href="javascript:void(0)" @click="sortOrder('asc', 'id')"> {{ $t('sorting.created_at_old') }}</a>
                </li>
                <li><a href="javascript:void(0)" @click="sortOrder('desc', 'id')"> {{
                    $t('sorting.created_at_new')
                  }}</a>
                </li>
              </ul>
            </div>

            <filter-dropdown-button @filter="filterResult" @reset="resetFilter">
              <div class="uk-child-width-1-2@s uk-grid-small" uk-grid>
                <app-multiselect v-model="content_ids" :allow-empty="true" :is-multiple="true"
                                 :options="userList" :placeholder="$t('exam.choose_content')"
                                 :title="$t('messages.content')"
                                 @input="getAssignments"/>

                <app-multiselect v-model="assignment_ids" :allow-empty="true" :is-multiple="true"
                                 :options="assignmentLoading ? [] : assignmentList"
                                 :placeholder="assignmentLoading ? $t('general.loading') + '...' : $t('exam.choose_education')"
                                 :title="$t('education.education')"/>

                <app-multiselect v-model="file_category_ids" :allow-empty="true" :is-multiple="true"
                                 :options="contentTypeOptions" :placeholder="$t('general.select')"
                                 :title="$t('general.content_type')"/>

                <AppDatePicker v-model="selectedDate"
                               :label="$t('general.date')"
                               :show-presets="true"
                               :show-time="false"
                               mode="range"
                />
                <UserStatusFilter v-model="user_status"/>
              </div>
            </filter-dropdown-button>

            <excel-download-button
                :loading="isReportDownloading"
                :tooltipText="$t('filters.export_excell')"
                @download="exportUserContents"
            />
          </div>
        </div>
      </div>

      <default-loading v-if="tableLoading"></default-loading>
      <template v-else>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col"> {{ $t('general.training_name') }}</th>
              <th scope="col"> {{ $t('general.content_title') }}</th>
              <th scope="col"> {{ $t('general.user_first_name') }}</th>
              <th scope="col"> {{ $t('general.user_last_name') }}</th>
              <th scope="col"> {{ $t('general.user_status') }}</th>
              <th scope="col">{{ $t("general.assignment_status") }}</th>
              <th scope="col"> {{ $t('excel.heading.email') }}</th>
              <th scope="col"> {{ $t('general.register_number') }}</th>
              <th scope="col"> {{ $t('excel.heading.started_at') }}</th>
              <th scope="col"> {{ $t('excel.heading.completed_at') }}</th>
              <th scope="col"> {{ $t('general.deleted_at') }}</th>
              <th scope="col">{{ $t('general.completion_percentage') }}</th>
              <th scope="col"> {{ $t('general.completion_status') }}</th>
              <th scope="col"> {{ $t('general.point') }}</th>
            </tr>
            </thead>
            <tbody class="list">
            <template v-for="item in formattedItems">
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.assignment_name }}</td>
                <td>{{ item.content_name }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.surname }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.assignment_status_id }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.registration_number }}</td>
                <td> {{ item.start_date }}</td>
                <td> {{ item.end_date }}</td>
                <td> {{ item.deleted_at }}</td>
                <td> {{ item.completion_percentage }}%</td>
                <td> {{ item.is_completed }}</td>
                <td> {{ item.is_completed === $t('general.completed') ? item.point : '-' }}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </template>
    </div>
  </div>
</template>

<script>
import reports, { GET_ITEMS, MODULE_NAME, SUCCESS } from "@/core/services/store/reports.module";

import store from '@/core/services'
import moment from "moment-timezone";
import axios from "axios";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/assets/components/Pagination";
import AppMultiselect from "@/view/components/select/app-multiselect/app-multiselect.vue";
import { getSubCompanyId } from "@/core/services/store.js";
import FilterDropdownButton from "@/view/components/filter/FilterDropdownButton.vue";
import UserStatusFilter from "@/view/company/User/components/UserStatusFilter.vue";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";
import AppDatePicker from "@/view/components/ui/AppDatePicker.vue";
import { showError } from "@/utils/alertUtils";
import { CONTENT_TYPES } from "@/core/constant/content-types";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "ReportUsers",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule)
      }
    }

    registerStoreModule(_MODULE_NAME, reports)
  },
  components: {
    ExcelDownloadButton,
    DefaultLoading,
    Pagination,
    AppMultiselect,
    FilterDropdownButton,
    UserStatusFilter,
    AppDatePicker
  },
  data() {
    return {
      from_date: null,
      to_date: null,
      selectedDate: null,
      pagination: null,
      content_ids: [],
      assignment_ids: [],
      file_category_ids: [],
      infoMessage: null,
      page: 1,
      per_page: 10,
      formattedItems: [],
      userList: [],
      assignmentList: [],
      assignmentLoading: false,
      tableLoading: false,
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      user_status: null,
      isReportDownloading: false
    }
  },
  computed: {
    contentTypeOptions() {
      return CONTENT_TYPES.map((item) => ({
        id: item.id,
        name: this.$t(item.key_name),
      }));
    },
    success() {
      return store.getters[_MODULE_NAME + '/' + SUCCESS]
    }
  },
  methods: {
    checkInitialState() {
      this.infoMessage = this.$t('general.user_content_warn_info');
    },
    getMissingFilterMessage() {
      const hasContent = this.content_ids.length > 0;
      const hasAssignment = this.assignment_ids.length > 0;
      const hasContentType = this.file_category_ids.length > 0;

      // Tek başına içerik türüyle filtreleme yapılabilir. Ancak içerik
      // seçilmişse ilgili eğitimin seçilmesi zorunlu olmaya devam eder.
      if (hasContent && !hasAssignment) {
        return this.$t('exam.choose_education');
      }

      if (hasContentType || hasContent) {
        return null;
      }

      return `${this.$t('exam.choose_content')} / ${this.$t('general.content_type')}`;
    },
    extractIds(selectedItems) {
      if (!selectedItems?.length) return [];
      if (selectedItems.some((item) => item?.id === 'all')) return [];
      return selectedItems
          .map((item) => item?.id)
          .filter((id) => id !== null && id !== undefined && id !== '');
    },
    extractContentIds() {
      return this.extractIds(this.content_ids);
    },
    extractAssignmentIds() {
      return this.extractIds(this.assignment_ids);
    },
    exportUserContents() {
      if (this.isReportDownloading) {
        return;
      }

      const missingMessage = this.getMissingFilterMessage();
      if (missingMessage) {
        this.infoMessage = null;
        showError(missingMessage);
        return;
      }

      this.isReportDownloading = true;

      axios.get(process.env.VUE_APP_BACKEND_APP_URL + '/api/report/export/user-contents', {
        responseType: 'blob',
        params: {
          content_ids: JSON.stringify(this.extractContentIds()),
          assignment_ids: JSON.stringify(this.extractAssignmentIds()),
          file_category_ids: JSON.stringify(this.extractIds(this.file_category_ids)),
          sort: this.filter.sort,
          order: this.filter.order,
          like: this.filter.search,
          from_date: this.from_date,
          to_date: this.to_date,
          report: Math.random() * 9999999,
          user_status: this.user_status
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + this.secureLocalStorage("token"),
          Company: getSubCompanyId?.value,
        }
      }).then((response) => {
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        let day = moment().format('YYYYMMDDHHMMSS');
        let fileName = 'user_contents_report_list_' + day + '.xlsx';
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        this.isReportDownloading = false;
      }).catch(() => {
        this.isReportDownloading = false;
      });
    },
    resetFilter() {
      this.content_ids = [];
      this.assignment_ids = [];
      this.file_category_ids = [];
      this.assignmentList = [];
      this.selectedDate = null;
      this.user_status = null;
    },
    filterResult(options = {}) {
      this.tableLoading = true;
      const missingMessage = this.getMissingFilterMessage();
      if (missingMessage) {
        options.preventClose?.();
        this.infoMessage = null;
        showError(missingMessage);
        this.tableLoading = false;
        return false;
      }

      this.infoMessage = null;

      let filters = {
        content_ids: JSON.stringify(this.extractContentIds()),
        assignment_ids: JSON.stringify(this.extractAssignmentIds()),
        file_category_ids: JSON.stringify(this.extractIds(this.file_category_ids)),
        sort: this.filter.sort,
        order_by: this.filter.order,
        like: this.filter.search,
        per_page: this.per_page,
        page: this.page,
        from_date: this.selectedDate?.start ? new Date(this.selectedDate.start).toISOString().split('T')[0] : null,
        to_date: this.selectedDate?.end ? new Date(this.selectedDate.end).toISOString().split('T')[0] : null,
        user_status: this.user_status
      };
      this.from_date = filters.from_date;
      this.to_date = filters.to_date;
      store.dispatch(_MODULE_NAME + '/' + GET_ITEMS, {
        url: 'api/report/user-contents',
        filters: filters
      }).then(response => {
        this.tableLoading = false;
        if (response.status) {
          let results = [];
          let items = response.data;
          this.pagination = items;
          items.data.forEach(item => {
            let completeStatus;
            if (item.completed_at) {
              completeStatus = this.$t('general.completed')
            } else if (item.started_at && !item.completed_at) {
              completeStatus = this.$t('general.on_going')
            } else {
              completeStatus = this.$t('general.waiting')
            }

            results.push({
              id: item.id,
              assignment_name: item.assignment_title,
              content_name: item.content_title,
              name: item.name,
              surname: item.surname,
              email: item.email,
              point: item.point,
              status: item.status_id === 1 ? this.$t('general.active') : this.$t('general.passive'),
              registration_number: item.registration_number ?? '-',
              start_date: item.started_at ? moment(item.started_at).add("3", 'hours').format('DD/MM/YYYY HH:mm') : '-',
              end_date: item.completed_at ? moment(item.completed_at).add("3", 'hours').format('DD/MM/YYYY HH:mm') : '-',
              deleted_at: item.deleted_at ? moment(item.deleted_at).format('DD/MM/YYYY HH:mm') : '-',
              completion_percentage: item.completion_percentage,
              is_completed: completeStatus,
              assignment_status_id: item.assignment_status_id === 1 ? this.$t('general.active') : this.$t('general.passive')
            });
          })
          this.formattedItems = results;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    getContent() {
      store.dispatch(_MODULE_NAME + '/' + GET_ITEMS, {
        url: 'api/report/get-contents',
        filters: {
          sort: 'desc',
          order_by: 'id',
          program: true,
          sections: false,
          all: true
        }
      }).then(response => {
        if (response.status) {
          let results = [{
            id: "all",
            name: this.$t("general.all"),
          }];
          let items = response.data;
          if (items.length > 0) {
            items.forEach(item => {
              results.push({
                id: item.id,
                name: `${item.title} - ${item.name}`,
              });
            })
          }
          this.userList = results;
        }
      });
    },
    getAssignments() {
      this.assignmentLoading = true;
      let ids = [];
      if (this.content_ids.length > 0) {
        this.content_ids.every((item) => {
          if (item.id === 'all') {
            ids = [];
            return false
          } else {
            ids.push(item.id);
            return true;
          }
        });
      }
      store.dispatch(_MODULE_NAME + '/' + GET_ITEMS, {
        url: 'api/assignment',
        filters: {
          page: 0,
          order: 'id',
          sort: 'desc',
          content_ids: JSON.stringify(ids),
        }
      }).then(response => {
        this.assignmentLoading = false;
        if (response.status) {
          let results = [{
            id: "all",
            name: this.$t("general.all"),
          }];
          let items = response.data;
          items.forEach(item => {
            results.push({
              id: item.id,
              name: item.name,
            });
          })
          this.assignmentList = results;
        }
      }).catch(() => {
        this.assignmentLoading = false;
      });
    },
    sortOrder(order, sort) {
      this.page = 1;
      this.filter.order = order;
      this.filter.sort = sort;
      this.filterResult();
    },
    setPage(page) {
      this.page = page;
      this.filterResult()
    },
  },
  mounted() {
    this.getContent();
    this.checkInitialState();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500)
  },
  watch: {
    success: function (val) {
      if (val) {
        this.filterResult()
      }
    },
    'filter.search': function () {
      this.debouncedFilterSearch()
    },
  },
};
</script>

<style scoped>

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}
</style>
